import { render, staticRenderFns } from "./GlobalDialog.vue?vue&type=template&id=dee484e6"
import script from "./GlobalDialog.vue?vue&type=script&lang=js"
export * from "./GlobalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports